"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _analyticsConstants = require("./analyticsConstants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Heap extends _react.Component {
  constructor() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    super(...args);
    (0, _defineProperty2.default)(this, "setHeap", () => {
      if (!window["heap"]) {
        window.heapReadyCb = window.heapReadyCb || [];
        window.heap = window.heap || [];
        window.heap.load = function (e, t) {
          window.heap.envId = e;
          window.heap.clientConfig = t = t || {};
          window.heap.clientConfig.shouldFetchServerConfig = !1;
          var a = document.createElement("script");
          a.type = "text/javascript";
          a.async = !0;
          a.src = "https://cdn.us.heap-api.com/config/" + e + "/heap_config.js";
          var r = document.getElementsByTagName("script")[0];
          r.parentNode.insertBefore(a, r);
          var n = ["init", "startTracking", "stopTracking", "track", "resetIdentity", "identify", "getSessionId", "getUserId", "getIdentity", "addUserProperties", "addEventProperties", "removeEventProperty", "clearEventProperties", "addAccountProperties", "addAdapter", "addTransformer", "addTransformerFn", "onReady", "addPageviewProperties", "removePageviewProperty", "clearPageviewProperties", "trackPageview"];
          var i = function (e) {
            return function () {
              var t = Array.prototype.slice.call(arguments, 0);
              window.heapReadyCb.push({
                name: e,
                fn: function () {
                  window.heap[e] && window.heap[e].apply(window.heap, t);
                }
              });
            };
          };
          for (var p = 0; p < n.length; p++) window.heap[n[p]] = i(n[p]);
        };
        const loadConfig = {
          eventPropertiesStorage: "localstorage",
          metadataStorage: "localstorage",
          secureCookie: true
        };
        if (this.props.domains) {
          loadConfig["supportedDomains"] = this.props.domains;
        }
        window.heap.load(this.props.heapId, loadConfig);
      }
    });
    (0, _defineProperty2.default)(this, "heapIdentify", () => {
      if (!window["heap"]) return;
      const {
        member_key,
        first_name,
        last_name,
        member_id
      } = this.props.member;
      const {
        key,
        name,
        ocid
      } = this.props.program;
      window.heap.identify(member_id);
      window.heap.addUserProperties({
        Name: "".concat(first_name, " ").concat(last_name),
        MCID: "".concat(member_key),
        PCID: "".concat(key),
        programName: "".concat(name),
        OCID: "".concat(ocid)
      });
    });
  }
  componentDidMount() {
    this.heapIdentify();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.member.member_key !== this.props.member.member_key || prevProps.program.key !== this.props.program.key) {
      this.heapIdentify();
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.setHeap());
  }
}
exports.default = Heap;
Heap.propTypes = {
  /** Program object. Will fire heap.identify if passed [member_id, first_name, last_name] */
  program: _propTypes.default.shape({
    key: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    ocid: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    name: _propTypes.default.string
  }),
  /** Member object. Will fire heap.identify if passed [member_id, first_name, last_name] */
  member: _propTypes.default.shape({
    member_key: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    member_id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    first_name: _propTypes.default.string,
    last_name: _propTypes.default.string
  }),
  /** Heap account Id. */
  heapId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /** supportedDomains for session association tracking */
  domains: _propTypes.default.array
};
Heap.defaultProps = {
  program: _analyticsConstants.PROGRAM,
  member: _analyticsConstants.MEMBER,
  heapId: _analyticsConstants.HEAP_ACCOUNT_ID,
  domains: null
};